import { Mapper } from 'src/base/mapper'
import { PlanTypeEntity } from 'src/data/entities/plan.entity'
import { ProductTypeEntity } from 'src/data/entities/product.entity'
import { PlanTypeModel } from 'src/domain/models/plan.model'
import { ProductTypeModel } from 'src/domain/models/product.model'

export class ProductMapper extends Mapper<ProductTypeEntity, ProductTypeModel> {
	mapFrom(param: ProductTypeEntity): ProductTypeModel {
		return {
			productId: param.productId,
			productName: param.productName,
			productDescription: param.productDescription,
			isActive: param.isActive,
			plans: param.plans.map((plan: PlanTypeEntity) => ({
				...plan,
				pricePerSeat: 0,
			})) as PlanTypeModel[],
			productPicture: param.productPicture,
		}
	}

	mapTo(param: ProductTypeModel): ProductTypeEntity {
		return {
			productId: param.productId,
			productName: param.productName,
			productDescription: param.productDescription,
			isActive: param.isActive,
			plans: param.plans,
			productPicture: param.productPicture,
		}
	}
}
